import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";
import axiosClient from "../../axios-client";

const ResetPassword = () => {
  const [newPassword, setNewPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  console.log(message, "reset");
  const [loading, setLoading] = useState(false);
  const { token } = useParams();
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axiosClient.post(`/users/reset-password/${token}`, {
        newPassword,
      });

      if (res.status === 200) {
        setMessage(res.data.message);
        alert(res.data.message);
        window.location.href = "/";
      }
    } catch (error) {
      setMessage("Error: " + error.response.data.message);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full">
        <h2 className="text-2xl font-semibold text-center mb-4">
          Reset Password
        </h2>
        <p className="text-gray-600 text-center mb-6">
          Enter your New Password to reset your password.
        </p>
        {message && (
          <p className="text-green-600 text-center mb-4">{message}</p>
        )}
        {error && <p className="text-red-600 text-center mb-4">{error}</p>}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block font-semibold mb-2">New Password</label>
            <input
              type="password"
              placeholder="New Password"
              value={newPassword}
              className="w-full px-4 py-2 border rounded-md focus:ring-black"
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
            {message && <p className="text-green-500 mt-2">{message}</p>}
          </div>
          <button
            type="submit"
            className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-md font-semibold"
            disabled={loading}
          >
            {loading ? "Sending..." : " Reset "}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
